<template>

    <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
      <z-page :title="title">
        <w-card bg-color="" class="">
            <div class="w-flex wrap smd-column" >
                <div class="grow " style="line-height: 35px">
                 <table >
                  <tbody>
                    <tr class="row_data">
                       <td><b>Tarikh Mohon / Masa</b></td>  
                       <td><b>:</b></td>
                       <td>{{data.tarikh_mohon}}</td>
                    </tr>
                    <tr class="row_data">
                       <td><b>No Permohonan</b></td>
                       <td><b>:</b></td>
                       <td>{{data.no_permohonan}}</td>
                    </tr>
                    <tr class="row_data">
                       <td><b>ID Premis / Nama</b></td>
                       <td><b>:</b></td>
                       <td>{{data.nama_premis}}</td>
                    </tr>
                    <tr class="row_data">
                       <td><b>Bilangan Ternakan</b></td>
                       <td><b>:</b></td>
                       <td>{{data.bil_ternakan}}</td>
                    </tr>
                    </tbody>
                    </table>
                  </div>
                <div class="mx2"></div>
                <div class="grow " style="line-height: 35px">
                 <table >
                  <tbody>
                    <tr class="row_data">
                       <td><b>ID Ternakan Nama</b></td>
                       <td><b>:</b></td>
                       <td>{{data.nama_premis}}</td>
                    </tr>
                    <tr class="row_data">
                       <td><b>Jantina </b></td>
                       <td><b>:</b></td>
                       <td>{{data.jantina}}</td>
                    </tr>
                    <template v-if="data.lkp_art_id == 1">
                    <tr class="row_data">
                       <td><b>Tarikh Check In Premis </b></td>
                       <td><b>:</b></td>
                       <td>{{data.tarikh_biang_format}}</td>
                    </tr>
                  </template>
                    <tr class="row_data">
                       <td><b>Nama Pegawai Pemeriksa</b></td>
                       <td><b>:</b></td>
                       <td>{{data.pemeriksa}}</td>
                    </tr>
                    <tr class="row_data">
                       <td><b>Status</b></td>
                       <td><b>:</b></td>
                       <td>{{data.status_keterangan}}</td>
                    </tr>
                    </tbody>
                 </table>
                </div>
              </div>
             </w-card>
                 <w-flex justify-end class="mt2">
                    <w-button class="mr2" v-if="data.lkp_status_id ==35"  bg-color="success" @click="sahkan(18)">
                    <w-icon m class="mr2">fal fa-check-circle</w-icon>SAHKAN
                      </w-button>
                      <br>
                      <w-button class="mr2" v-if="data.lkp_status_id ==35 " bg-color="error" @click="sahkan(27)">
                    <w-icon m class="mr2">fal fa-times-circle</w-icon>SEMAK SEMULA
                </w-button>
               </w-flex>
        <div class="mt2 text-left">
            <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
          </div>
      </z-page>
    </zen-one>
  </template>
  
  <script>
  import { reactive } from 'vue'
  import ZResource from '@/Modules/z-resource'
  // import Ternakan from './Show/Ternakan.vue';
  import VueQrcode from 'vue-qrcode'
  
  export default {
    extends: ZResource,
    components: {
      VueQrcode
    },
    props: {
      id: [Array, Object, String],
  
    },
    data() {
      return {
        resourceurl: 'art.permohonan',
        crumbs     : [
          { label: this.$page.props.app_name, route: '/home' },
          { label: 'Penilaian Daya Biak & Fertiliti', route: '/pdbf' },
          { label: 'Pemeriksaan Fertiliti', route: 'art/permohonan/ferteliti/{id}' },
        ],
        title        : '',
        data         : {id : 0},
        activeTab    : 0,
        ternakan_list: [],
      }
    },
    methods: {
  
      tutup(){
           this.$inertia.visit(window.route('pdbf.permohonan.index'));
         },
  
      // cetak(data){
      //     // this.$inertia.visit(route("kursus.kursus.peserta.sijil_peserta", dt.peseta_user_id) +"?kursus_id="+dt.id,);
      //     window.open( window.route('art.permohonan.cetak', data), '_blank');
      // },
  
      sahkan(item) {
          this.loading = true;
          this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
          if (result.value) {
            if(this.data.id > 0){
              this.data.lkp_status_id = item;
              this.data.peternak = 1;
            this.$zcomm.update('art.ai.update', this.data.id, this.data)
                .then(res => {
                  console.log(res);
                    this.dialog.show = false;
                    this.$inertia.reload();
                })
                .catch(err => {
  
                })
                .finally(() => {
                  
                  this.$inertia.visit(this.$page.url)
                });
                this.dialog.loading = false;
            }
          }else{ this.loading = false;}
  
          }) 
        },
  
  
    
      getData()
      {
        this.$zcomm.get(this.api_service + 'pdbf/show/'+this.id, {}).then(res => {
          this.data = res
          this.title = 'Senarai Permohonan Perkhidmatan Penilaian Daya Biak & Fertiliti'
        })
      },
  
      
     
  
    },
    watch: {
  
    },
    mounted() {
      this.getData();
      
      
    },
  }
  </script>
  
  
  
  